/**
 * 区域能耗接口
 */
import Axios from '@/components/api/axios.js'
export default {
	/**
	 * 根据单位获取区域能耗
	 */
	getFindAreausePiwerList(unitId, success, failure) {
		Axios.post('/areausePower/getFindAreausePiwerList.do', {
			unitId,
		}, success, failure)
	},
	/**
	 * 根据单位和应用类型获取区域能耗
	 */
	getAreausePiwerListUnitAndApptype(unitId,appType,success, failure) {
		Axios.post('/areausePower/getAreausePiwerListUnitAndApptype.do', {
			unitId,
			appType,
		}, success, failure)
	},
	/**
	 * 查询首页的水电气用量
	 */
	getWaterAndElectricity(unitId,dataType, success, failure) {
		Axios.post('/areausePower/getWaterAndElectricity.do', {
			unitId,
			dataType,
		}, success, failure)
	},
	/**
	 * 查询首页分析功能
	 */
	getHomeAnalysis(unitId,type,success,failure){
		Axios.post('/areausePower/getHomeAnalysis.do', {
			unitId,
			type,
		}, success, failure)
	},
	/**
	 * 查询分项能耗概况
	 */
	getSubOption(unitId,appType,success,failure){
		Axios.post('/areausePower/getSubOption.do', {
			unitId,
			appType,
		}, success, failure)
	},
	/**
	 * 查询区域能耗统计
	 */
	getStatistics(unitId,appType,dateType,bgTime,endTime,lasBgTime,lasEndTime,success,failure){
		Axios.post('/areausePower/getStatistics.do', {
			unitId,
			appType,
			dateType,
			bgTime,
			endTime,
			lasBgTime,
			lasEndTime,
		}, success, failure)
	},
	/**
	 * 查询能耗分析
	 */
	getConsumptionAnalysis(variable,nowDate,success,failure){
		Axios.post('/areausePower/getConsumptionAnalysis.do', {
			variable,
			nowDate,
		}, success, failure)
	},
	/**
	 * 能耗排行
	 */
	getRanking(unitId,appType,nowDate,success,failure){
		Axios.post('/areausePower/getRanking.do', {
			unitId,
			appType,
			nowDate,
		}, success, failure)
	}
	
}